<template>
    <require from="../../parent-child-select/parent-child-select"></require>
    <parent-child-select
            items.bind="selectedObjectService.selectedObject.attributes"
            objecttypetoadd.bind="'Attribute'"
            sortable.bind="false"
    >
    </parent-child-select>
</template>
